'use client';

import styled from 'styled-components';

const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 30px 20px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  text-align: center;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.rootColor.black12};
  font-size: 24px;
  font-weight: 800;
  line-height: normal;
`;

const Description = styled.p`
  color: ${({ theme }) => theme.rootColor.gray7B};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

const MyPickSectionStyled = {
  Container,
  TitleWrapper,
  Title,
  Description,
};

export default MyPickSectionStyled;
